import { endAjaxLoading } from '@/util/loading'
import { Message } from 'element-ui'
import i18n from '@/lang/index'
import config from '@/config'
import helper from '@/util/signinHelper'
import { setCookies, getCookies } from '@/util/cookies'
import store from '@/store'
import { HTMLdecode } from '@/util/utils'
import { FILTER_URLS } from '@/constants/filterUrls.js';
function respHandler(resp) {
  if (!resp.config.byPassLoading) {
    endAjaxLoading()
  }

  //if response is session_timeout, logout.
  if (resp.data.code === 401) helper.signOut(null,'timeout')
  else {
    //if response is not session_timeout, then update token.
    const token = getCookies('xtoken')
    setCookies('xtoken', token)
  }

  // 新增security management 1201 647 不做msg提示
  const toIgnore = [0, 521, 638, 639, 647, 1201, 1213, 637, 1500]

  if (resp.data.hasOwnProperty('code') && !toIgnore.includes(resp.data.code)) {
    let respMsg = getResponseMsg(resp.data.code)
    //if response code: 585, show error msg
    if (resp.data.code === 585) {
      respMsg = getWithdrawMsg(resp.data.code, resp.data.data[0])
      Message({
        message: respMsg,
        type: 'error',
      })
    } else if (resp.data.code === 580) {
      respMsg = getWithdrawalBlacklist()
      Message({
        message: respMsg,
        type: 'error',
      })
    } else if (resp.data.code === 589) {
      respMsg = getWithdrawErrMsg(resp.data.code, JSON.parse(resp.data.data).validAmount)
      Message({
        message: respMsg,
        type: 'error',
      })
    }
    //if response code: 8xx, show error msg
    else if (resp.data.code >= 800) {
      Message({
        message: getLoyaltyMsg(resp.data.code, resp.data.data),
        type: 'error',
      })
    }
    //if response code: 5xx, show error msg
    else if (resp.data.code >= 500 && resp.data.code !== 600) {
      Message({
        message: respMsg,
        type: 'error',
      })
    } else if (resp.data.code === 600) {
      if (!resp.config.url.includes('/web-api/cp/api/transfer/getDeductCredit')) {
        Message({
          message: respMsg,
          type: 'error',
        })
      }
    }
    //if response code: 4xx, show warning msg
    else if (resp.data.code >= 400) {
      Message({
        message: respMsg,
        type: 'warning',
      })
    }
  }
  if (resp.data && FILTER_URLS) {
    for (let i = 0; i < FILTER_URLS.length; i++) {
      if (resp.config.url.includes(FILTER_URLS[i])) {
        resp.data = HTMLdecode(resp.data)
        break;
      }
    }
  }
  return resp
}

function getResponseMsg(code) {
  const email = store.state.regulator.contactEmail || config.info.getEmail(store.state.common.regulator)
  return i18n.t('responseMsg.' + code, { email: email })
}

function getLoyaltyMsg(code, data) {
  return i18n.t('responseMsg.' + code, data)
}

function getWithdrawMsg(code, amount) {
  return i18n.t('responseMsg.' + code, { amount: amount })
}

function getWithdrawErrMsg(code, validAmount) {
  return i18n.t('responseMsg.' + code, { validAmount: validAmount })
}

function getWithdrawalBlacklist() {
  const supportEmail = config.info.getWithdrawalEmail(store.state.common.regulator)
  return i18n.t('withdraw.default.blackList', { supportEmail: supportEmail })
}

export default respHandler
